<template>
  <div class="flex justify-center rounded-lg mx-2 mt-12">
    <div class="">
      <div
        class="container mx-auto px-4 p-1 bg-basic-darck shadow-md drop-shadow-2xl lg:p-2 rounded-md place-items-center"
      >
        <div class="flex justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="#9d2890"
            class="w-36 h-36"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"
            />
          </svg>
        </div>
        <div class="">
          <p class="text-md text-white text-center font-bold">
            تأكيد إلغاء الإشتراك؟
          </p>
          <div class="border border-b-4 border-color mx-auto mt-1 w-36"></div>
          <div class="m-2 mt-6 md:w-5/6 w-full text-center mx-auto" dir="rtl">
            <p class="text-white md:text-md text-sm">
              هل أنت متاكد من أنك تريد إالغاء إشتراكك في خدمة "ناسنا". في حالة
              إلغائك للإشتراك لن تتمكن من الإستمتاع بـ
            </p>
            <div class="flex md:justify-center my-3" dir="rtl">
             <!-- code 802621 keyword غ1 او غ2 -->
             <div class="space-y-3 text-center">
               <!-- Weekly unsubscription -->
               <div class="space-y-1">
                 <p class="text-white md:text-md text-sm">
                   لإلغاء الإشتراك اليومي, أرسل 
                   <span class="font-bold text-pink-400 cursor-pointer border-b border-pink-400" @click="copyToClipboard(stcDailyKeyword)" :title="'انقر للنسخ: ' + stcDailyKeyword">
                     {{ stcDailyKeyword }}
                   </span>
                   إلى 
                   <span class="font-bold text-pink-400 cursor-pointer border-b border-pink-400" @click="copyToClipboard(stcShortCode)" :title="'انقر للنسخ: ' + stcShortCode">
                     {{ stcShortCode }}
                   </span>
                 </p>
                 <p class="text-white md:text-md text-sm">
                   To cancel Daily subscription, send 
                   <span class="font-bold text-pink-400 cursor-pointer border-b border-pink-400" @click="copyToClipboard(stcDailyKeyword)" :title="'Click to copy: ' + stcDailyKeyword">
                     {{ stcDailyKeyword }}
                   </span>
                   to 
                   <span class="font-bold text-pink-400 cursor-pointer border-b border-pink-400" @click="copyToClipboard(stcShortCode)" :title="'Click to copy: ' + stcShortCode">
                     {{ stcShortCode }}
                   </span>
                 </p>
               </div>
               
               <!-- Monthly unsubscription -->
               <div class="space-y-1">
                 <p class="text-white md:text-md text-sm leading-6">
                   لإلغاء الإشتراك الإسبوعي, أرسل 
                   <span class="font-bold text-pink-400 cursor-pointer border-b border-pink-400" @click="copyToClipboard(stcWeeklyKeyword)" :title="'انقر للنسخ: ' + stcWeeklyKeyword">
                     {{ stcWeeklyKeyword }}
                   </span>
                   إلى 
                   <span class="font-bold text-pink-400 cursor-pointer border-b border-pink-400" @click="copyToClipboard(stcShortCode)" :title="'انقر للنسخ: ' + stcShortCode">
                     {{ stcShortCode }}
                   </span>
                 </p>
                 <p class="text-white md:text-md text-sm leading-6">
                   To cancel weekly subscription, send 
                   <span class="font-bold text-pink-400 cursor-pointer border-b border-pink-400" @click="copyToClipboard(stcWeeklyKeyword)" :title="'Click to copy: ' + stcWeeklyKeyword">
                     {{ stcWeeklyKeyword }}
                   </span>
                   to 
                   <span class="font-bold text-pink-400 cursor-pointer border-b border-pink-400" @click="copyToClipboard(stcShortCode)" :title="'Click to copy: ' + stcShortCode">
                     {{ stcShortCode }}
                   </span>
                 </p>
               </div>
             </div>
            </div>
          </div>
          <div class="m-3 relative md:w-96 mx-auto" dir="rtl"></div>

         
          <div class="flex justify-center my-6 ">

          <div class="flex justify-center my-6">
            <router-link to="/">
              <button
                type="submit"
                class="text-white focus:ring-0 focus:outline-none focus:ring-pink-300 rounded-lg text-md w-full sm:w-auto px-5 py-2.5 text-center border border-color w-btn text-white"
              >
                تراجع
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
// import SpinnerView from "@/components/SpinnerView.vue";
import { useAuthStore } from "@/stores/auth";
import { mapActions } from "pinia";
import { useToast } from "vue-toastification";
export default {
  data() {
    return {
      copyText1: 'غ 1',
      copyText2: '801167',
      shortCode: '801167',
      unsubMessage: 'غ 1',
      stcShortCode: '802621',
      stcDailyKeyword: 'غ1',
      stcWeeklyKeyword: 'غ2',
      toast: useToast()
    }
  },
  components: {
    // SpinnerView,
  },
  computed: {

    unsubscribeLink() {
      // This will encode the message for URL use
      const encodedUnsubMessage = encodeURIComponent(this.unsubMessage);
      return `sms:${this.shortCode}?&body=${encodedUnsubMessage}`;
    },
  },
  methods: {
    ...mapActions(useAuthStore, ["unSubscribeStc", "wipeUserData"]),
    async cancelSubscription() {
      await this.unSubscribeStc().then((response) => {
        this.redirectUser(response);
      });
    },
     async  redirectUser(response) {
      if (response.data.success) {
        // Update both store and local state
        const authStore = useAuthStore();
        authStore.isActive = false;
        this.isActive = false;
         this.wipeUserData();
         this.toast.success("تم إلغاء الإشتراك بنجاح");
        return this.$router.push({ name: "home" });
      }
    },
    async copyToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text);
        this.toast.success(`تم نسخ: ${text}`);
      } catch (err) {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        this.toast.success(`تم نسخ: ${text}`);
      }
    },
  },
};
</script>

<style scoped>
.w-btn {
  width: 290px;
  align-self: right;
}

.btn-color {
  background-color: #9d2890;
}

.bg-basic {
  background-color: #181b30;
}
</style>
